module.exports = __webpack_public_path__ + "img/bg-about-us.a8466132.png";